// Product
export const SET_PRODUCT_LOADED = (state, isLoaded) => { state.productLoaded = isLoaded }
export const SET_PRODUCT_NAME = (state, name) => { state.productName = name }
export const SET_PRODUCT_PRICE = (state, price) => { state.productPrice = price }

// Header
export const SET_HEADER_ALIGNMENT = (state, alignment) => { state.headerAlignment = alignment }
export const SET_PRODUCT_NAME_ENABLED = (state, isEnabled) => { state.productNameEnabled = isEnabled }
export const SET_PRODUCT_PRICE_ENABLED = (state, isEnabled) => { state.productPriceEnabled = isEnabled }

// Gamepad
export const SET_GAMEPAD_BUTTONS_COLOR = (state, color) => { state.gamepadButtonsColor = color }
export const SET_AR_BUTTON_ENABLED = (state, isEnabled) => { state.arButtonEnabled = isEnabled }
export const SET_RESET_BUTTON_ENABLED = (state, isEnabled) => { state.resetButtonEnabled = isEnabled }
export const SET_DIMENSIONS_BUTTON_ENABLED = (state, isEnabled) => { state.dimensionsButtonEnabled = isEnabled }
export const SET_SCREENSHOT_BUTTON_ENABLED = (state, isEnabled) => { state.screenshotButtonEnabled = isEnabled }

// AR
export const SET_AR_LOADING = (state, isLoading) => { state.arLoading = isLoading }

// Glances
export const SET_GLANCED_OPTIONS_ITEM = (state, item) => { state.glancedOptionsItem = item }

// Error
export const SET_ERROR_DISPLAYED = (state, isDisplayed) => { state.errorDisplayed = isDisplayed }
export const SET_ERROR_MESSAGE = (state, message) => { state.errorMessage = message }
